<template>
  <GenericFragment
    title="NOA Management App"
    description="Simulated Feegow background with NOA micro-frontend injection."
    scriptName="noa-management-app"
  >
    <div
      style="width: 100%; height: 100%; margin: 0; padding: 0"
      id="management-app-container"
    ></div>
  </GenericFragment>
</template>

<script lang="ts" setup>
import { onMounted } from "vue";
import GenericFragment from "@/views/development/GenericFragment.vue";

// Make process.env.DEV_TK available at localStorage.tk to Simulate Feegow
const devTk = process.env.DEV_TK || localStorage.getItem("tk");

if (devTk) {
  localStorage.setItem("tk", devTk);
}

const props = {
  license: { id: 17973, name: "Bruno Fidalgo Medical Center" },
  session: {
    user: {
      id: 160044995,
      email: "dennys.oliveira@docplanner.com",
      admin: true,
      name: "Dennys Oliveira",
    },
  },
};

function waitForMountFunction(): Promise<any> {
  return new Promise((resolve, reject) => {
    const check = () => {
      const fn = (window as any)["noa-management-app"]?.mountApp;
      if (typeof fn === "function") {
        resolve(fn);
      } else {
        setTimeout(check, 100);
      }
    };
    check();
  });
}

onMounted(async () => {
  const mountFn = await waitForMountFunction();
  const container = document.getElementById("management-app-container");
  if (container && typeof mountFn === "function") {
    mountFn(container, props);
  }
});
</script>
